module.exports = __webpack_public_path__ + "static/media/trees.f42b5a0c.png";